import React from "react";
import dayjs from "dayjs";

function money(n, c = "GBP") {
  if (n == null) return "—";
  try { return new Intl.NumberFormat(undefined, { style: "currency", currency: c, maximumFractionDigits: 0 }).format(n); }
  catch { return `${c} ${Number(n).toLocaleString()}`; }
}

function appraisalBadge(date) {
  if (!date) return null;
  const days = dayjs(date).diff(dayjs(), "day");
  if (days < 0)   return <span className="text-xs text-white/20">Overdue</span>;
  if (days <= 30) return <span className="text-xs text-yellow-400 bg-yellow-500/10 border border-yellow-500/20 px-2 py-0.5 rounded-full">In {days}d</span>;
  return <span className="text-xs text-white/40">{dayjs(date).format("DD MMM YYYY")}</span>;
}

export default function TeamSalaryGrid({ loading, rows, onRowClick }) {
  if (loading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, i) => <div key={i} className="h-12 rounded-lg bg-white/5 animate-pulse" />)}
      </div>
    );
  }

  if (!rows?.length) {
    return <p className="text-white/30 text-sm py-4 text-center italic">No team salary data.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-white/5">
            {["Member", "Annual Salary", "Next Appraisal", "Last Increment", ""].map(h => (
              <th key={h} className="px-3 py-3 text-left text-xs text-[#00ff90]/40 uppercase tracking-wider font-medium">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id} className="border-b border-white/5 hover:bg-white/3 transition-colors">
              <td className="px-3 py-3">
                <div>
                  <p className="text-white font-medium">{r.name}</p>
                  <p className="text-white/30 text-xs">{r.role}</p>
                </div>
              </td>
              <td className="px-3 py-3 text-white/80 font-medium">{money(r.annualSalary, r.currency)}</td>
              <td className="px-3 py-3">{appraisalBadge(r.nextAppraisal)}</td>
              <td className="px-3 py-3">
                {r.lastIncrement?.date ? (
                  <div>
                    <span className="text-[#00ff90] text-xs font-medium">+{r.lastIncrement.deltaPct}%</span>
                    <span className="text-white/30 text-xs ml-2">{money(r.lastIncrement.from, r.currency)} → {money(r.lastIncrement.to, r.currency)}</span>
                    <p className="text-white/20 text-xs">{r.lastIncrement.date}</p>
                  </div>
                ) : <span className="text-white/20 text-xs">—</span>}
              </td>
              <td className="px-3 py-3">
                <button onClick={() => onRowClick(r)}
                  className="text-xs px-3 py-1.5 rounded-lg border border-[#00ff90]/20 bg-[#00ff90]/5 text-[#00ff90]/60 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors">
                  History
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}